import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import { useMediaQuery, Box, Container, Toolbar } from '@mui/material';

// project-imports
import Drawer from './Drawer';
import Header from './Header';
import Footer from './Footer';
import HorizontalBar from './Drawer/HorizontalBar';
import { HeaderActionProvider } from 'contexts/HeaderActionContext';
import { RolesProvider } from 'contexts/RolesContext';

import { DRAWER_WIDTH } from 'config';
import useConfig from 'hooks/useConfig';
import { dispatch } from 'store';
import { openDrawer } from 'store/reducers/menu';
import { MenuOrientation } from 'config';

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
  const theme = useTheme();
  const downXL = useMediaQuery(theme.breakpoints.down('xl'));
  const downLG = useMediaQuery(theme.breakpoints.down('lg'));

  const { container, miniDrawer, menuOrientation } = useConfig();

  const { pathname } = useLocation();
  // Full-bleed pages render edge-to-edge (no content padding / container
  // gutters); the page supplies its own internal padding. Used for the
  // immersive ticket detail view.
  const fullBleed = /\/tickets\/view\//.test(pathname);

  const isHorizontal =
    menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  // set media wise responsive drawer
  useEffect(() => {
    if (!miniDrawer) {
      dispatch(openDrawer(!downXL));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downXL]);

  return (
    <HeaderActionProvider>
      <RolesProvider>
      <Box sx={{ display: 'flex', width: '100%' }}>
        <Header />
        {!isHorizontal ? <Drawer /> : <HorizontalBar />}

        <Box
          component="main"
          sx={{
            width: `calc(100% - ${DRAWER_WIDTH}px)`,
            flexGrow: 1,
            p: fullBleed ? 0 : { xs: 2, md: 3 },
          }}
        >
          <Toolbar
            sx={{
              minHeight: { xs: 52, md: 52 },
              mt: isHorizontal ? 8 : 'inherit',
              mb: isHorizontal ? 2 : 'inherit',
            }}
          />
          <Container
            maxWidth={fullBleed ? false : container ? 'xl' : false}
            disableGutters={fullBleed}
            sx={{
              ...(container && !fullBleed && { px: { xs: 0, md: 2 } }),
              position: 'relative',
              minHeight: 'calc(100vh - 110px)',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Outlet />
            {!fullBleed && <Footer />}
          </Container>
        </Box>
      </Box>
      </RolesProvider>
    </HeaderActionProvider>
  );
};

export default MainLayout;
